<template>
	<div>
		<component :is="selComponent" @eventname="updateparent"></component>
	</div>
</template>

<script>
import Cart from "@/components/Cart.vue";
import CustomerDetails from "@/components/CustomerDetails.vue";
import Payment from "@/components/Payment.vue";
import MailTest from "@/components/MailTest.vue";
import Terms from "@/components/Terms.vue";
import Privacy from "@/components/PrivacyPolicy.vue";

export default {
	name: "App",
	selComponent: "",

	components: {
		Cart,
		CustomerDetails,
		Payment,
		MailTest,
		Terms,
		Privacy,
	},

	data() {
		return {
			selComponent: "Cart",
		};
	},
	// mounted() {

	//   var productControllerURL = this.apiBaseUrl + "product/getsingle/";

	// },
	methods: {
		updateparent(variable) {
			this.selComponent = variable;
		},

		// toggle() {
		//   if(this.selComponent=="Test1"){
		//     this.selComponent="Cart"
		//   }else{
		//     this.selComponent="Test1"
		//   }
		// }
	},
};

// /*
</script>



<style>
body {
	font: 12px;
	font-family: Lato Reg, Arial, Helvetica, sans-serif;
	/* padding:100px; */
	padding-top: 50px;
}

/* @import "~bootstrap/dist/css/bootstrap.css"; */
</style>




